import { configureStore } from "@reduxjs/toolkit";
import authreducer from "./authSlicer";
import profilereducer from "./ProfileSlicer";
const store = configureStore({
  reducer: {
    auth: authreducer,
    profile: profilereducer,
  },
});
export default store;
